import React from "react"


class Error extends React.Component {
    render = () => {
        return (
            <section className="messages-section">
                <div className="message-holder standalone">
                    <div className="component-holder no-padding">
                        <div className="warning-message with-logo">
                        <span className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
                            <g fill="none" fillRule="evenodd">
                                <path stroke="#323232" d="M9.495.704A.704.704 0 0 0 8.47.74C8.414.8.966 13.58.583 14.262a.927.927 0 0 0-.083.377c0 .428.28.78.556.838l15.678.023c.414 0 .766-.378.766-.861 0-.13-.03-.259-.061-.337L9.495.704z">

                                </path><text fill="#323232" fontFamily="ProximaNova-Extrabld, Proxima Nova" fontSize="11" fontWeight="600">
                                <tspan x="7.5" y="13">!</tspan>
                            </text>
                            </g>
                        </svg>
                        </span>
                            <h5 className="application-error">{this.props.error.title}</h5>
                            <ul className="error-desc">
                                {this.props.error.messages}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        )

    }
}

export default Error
